import React from "react";
import { rng } from "../../amorg-common";
import { Modal } from "../Modal";
import { Button } from "../button/Button";
import { ButtonSize, ButtonVariant } from "../button/Shared";
import { colors } from "../colors/color";
import { TextInput } from '../inputs/TextInput';
import { P, Small } from "../typography/Body";
import { Flex } from "./FlexHelpers";

type DeleteConfirmationButtonProps = {
    asIcon?: boolean,
    title?: string,
    buttonText: string,
    buttonSize?:ButtonSize,
    tooltipText?: string,
    tooltipHorizontalAlignment?: 'left' | 'right',
    confirmationHeading: string,
    confirmationText: string,
    requireKey: boolean,
    hideIcon?: boolean,
    onConfirmDelete: () => void,
    disabled?:boolean,
    fullWidth?:boolean,
    variant?: ButtonVariant
}
export function DeleteConfirmationButton(props: DeleteConfirmationButtonProps): JSX.Element {
    const [showModal, setShowModal] = React.useState(false);

    function handleClickButton() {
        setShowModal(true);
    }

    function handleConfirmClick() {
        props.onConfirmDelete();
        setShowModal(false);
    }

    return (
        <>
            {props.asIcon 
                ?
                <Button
                    toolTipText={props.tooltipText}
                    tooltipHorizontalAlignment={props.tooltipHorizontalAlignment}
                    variant={props.variant ? props.variant : "destructive"}
                    size={props.buttonSize || "42px"}
                    onClick={() => handleClickButton()}
                    icon={"interface_actions_delete"}
                    disabled={props.disabled} />
                :
                <Button
                    toolTipText={props.tooltipText}
                    tooltipHorizontalAlignment={props.tooltipHorizontalAlignment}
                    variant={props.variant ? props.variant : "destructive"}
                    onClick={() => handleClickButton()}
                    icon={props.hideIcon ? undefined : "interface_actions_delete"}
                    text={props.buttonText}
                    size={props.buttonSize || "42px"}
                    disabled={props.disabled} />
            }

            <DeleteConfirmationModal 
                showModal={showModal} 
                {...props}
                onCancel={() => setShowModal(false)}
                onConfirmDelete={handleConfirmClick} />

        </>
    )
}

type DeleteConfirmationModalProps = {
    showModal:boolean,
    asIcon?: boolean,
    title?: string,
    confirmationHeading: string,
    confirmationText: string,
    requireKey: boolean,
    buttonText: string,
    onConfirmDelete: () => void,
    onCancel: () => void,
}
export function DeleteConfirmationModal(props:DeleteConfirmationModalProps):JSX.Element
{
    const [confirmationKey, setConfirmationKey] = React.useState('');
    const [confirmationInput, setConfirmationInput] = React.useState('');

    React.useEffect(()=>{
        setConfirmationKey(getConfirmationKey());
        setConfirmationInput('');
    }, [props.showModal])

    function getConfirmationKey() {
        return rng.getRandomCharacters(
            4,
            ['upper']
        )
    }

    function handleConfirmationInputChange(value: string) {
        setConfirmationInput(value);
    }

    return (
        
        <Modal
            title={props.confirmationHeading}
            showModal={props.showModal}
            onCancel={props.onCancel}
            content={
                <Flex gap={16} justifyContent={"center"} flexDirection="column" alignItems="center">
        
                <Flex justifyContent="center" gap={16}>
                    <P>{props.confirmationText}</P>
                </Flex>
        
                {props.requireKey &&
                <Flex flexDirection="column" gap={16}>
                    <Flex flexDirection="row" gap={8}>
                        <span style={{ padding: '10px', border: `1px solid ${colors.text.state.error}` }}>
                            <b>{confirmationKey}</b>
                        </span>
                        <TextInput
                            value={confirmationInput}
                            onChange={value => handleConfirmationInputChange(value.toUpperCase())}
                        />
                    </Flex>
                    <Flex justifyContent="center">
                        <Small>
                        Indtast koden for at bekræfte sletning
                        </Small>
                    </Flex>
                </Flex>
                }

                <Flex justifyContent="space-between" width="100%">
                    
                    <Button 
                        onClick={props.onCancel}
                        variant="text"
                        text={"Annuller"} />
                    <Button 
                        onClick={props.onConfirmDelete}
                        variant="destructive"
                        disabled={props.requireKey && confirmationInput !== confirmationKey}
                        icon={"interface_actions_delete"}
                        text={props.buttonText} />
                    
                </Flex>
            </Flex>        
            }
        />
    );
}